module.exports = __webpack_public_path__ + "static/media/delivered-order-icon.c2f0cb5f.svg";